import React, {useRef, useState, useEffect} from 'react';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import useOutsideClick from '../../../../../../../../hooks/use-outside-click/lib/useOutsideClick';
import {useSelector, useDispatch} from 'react-redux';
import {userCountrySelector, lobSelector} from '../../../../../store/selectors';
import {changeCountryCode} from '../../../../../store/actions/onboarding';
import RadioButton from '../../GccComponents/RadioButton/RadioButton';

import * as S from './LanguageSelector.styles';

const LanguageSelector = ({classes}) => {
  const dispatch = useDispatch();
  const listRef = useRef();
  const userCountry = useSelector(userCountrySelector);
  const lob = useSelector(lobSelector);
  const [toggleOption, setToggleOption] = useState(true);
  const [dropdown, setDropDown] = useState(false);

  const handleChange = (state, item) => {
    setToggleOption(!state);
  dispatch(changeCountryCode(false)) 
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:signup:landing|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/home/',
      eVar37:
        item?.text === 'UAE'
          ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
          : 'domain_sbu:mypartner|domain_country:in|domain_currency:inr|domain_language:eng',
      prop54: 'myPartner_landing_countrySwitch',
    });
    toggleDropdown();
  };

  const toggleDropdown = () => setDropDown(!dropdown);

  useOutsideClick(listRef, () => {
    if (dropdown) {
      setDropDown(false);
    }
  });
  useEffect(() => {
    dispatch(changeCountryCode(false)) 
  }, []);
  const options = lob
    ? [
        {
          id: 'siudyc8',
          icon: 'https://assets-gos3.goibibo.com/myp_GCC_IND_flag-1674563464.png',
          text: 'India',
        },
      ]
    : [
        {
          id: 'siudyc8',
          icon: 'https://assets-gos3.goibibo.com/myp_GCC_IND_flag-1674563464.png',
          text: 'India',
        }
      ];

  return (
    <S.ContainerOuter>
      <S.Container className={classes} onClick={toggleDropdown}>
        <S.Flag>
        <img src="https://assets-gos3.goibibo.com/myp_GCC_IND_flag-1674563464.png" alt="flag" />
         
        </S.Flag>
        <S.Lang>IND | INR</S.Lang>
      </S.Container>

    </S.ContainerOuter>
  );
};

export default LanguageSelector;
